import axios from 'axios';
import { STRUCTURE_API_ROOT as API_ROOT } from './api.conf';
import API_ROUTES_STRUCTURE from './apiRoutesStructure';
import { AUTHENTICATION } from '../constants/global-constants';

class API {
  http;

  constructor() {
    const instance = axios.create({
      baseURL: API_ROOT
    });
    this.http = instance;
  }

  setAutorizationToken = (token, refreshToken) => {
    if (token) {
      localStorage.setItem(AUTHENTICATION.jwtTokenKey, token);
      if (refreshToken) {
        localStorage.setItem(AUTHENTICATION.refreshTokenKey, refreshToken);
      }
      this.http.defaults.headers.common.Authorization = `${AUTHENTICATION.bearerKey} ${token}`;
    } else {
      delete this.http.defaults.headers.common.Authorization;
      localStorage.clear();
    }
  };

  getListOforganizationalEntities = params =>
    this.http.get(`${API_ROUTES_STRUCTURE.organizationalEntitySearch}`, {
      params
    });

  getFilial = companyCode =>
    this.http.get(
      `${API_ROUTES_STRUCTURE.organizationalEntity}?path=${companyCode}`,
      {
        companyCode
      }
    );
}

export default new API();
